import type { FeedPost, FeedPostScope } from './types';

export type PostRemovalTarget = {
  groupId: string;
  /** Null when the scope isn't among the viewer's visible scopes — a Network
   *  leader may remove a post from a child Circle they don't belong to. */
  groupName: string | null;
  groupKind: FeedPostScope['groupKind'];
};

// The groups a leader's "Remove post from …" menu offers. The server decides
// which groups the viewer may remove the post from (`viewerCan.removeFrom`);
// this only picks among them for the surface. Inside a group's own feed that
// group is the one meant, when it is removable; elsewhere every removable
// group gets its own item (usually exactly one).
export function postRemovalTargets(
  post: Pick<FeedPost, 'scopes' | 'viewerCan'>,
  contextGroupId: string | undefined,
): ReadonlyArray<PostRemovalTarget> {
  const ids =
    contextGroupId !== undefined && post.viewerCan.removeFrom.includes(contextGroupId)
      ? [contextGroupId]
      : post.viewerCan.removeFrom;
  return ids.map((groupId) => {
    const scope = post.scopes.find((s) => s.groupId === groupId);
    return scope !== undefined
      ? { groupId, groupName: scope.groupName, groupKind: scope.groupKind }
      : // Only a parent Network's leader reaches a group outside their own
        // scopes, and a Network's children are Circles.
        { groupId, groupName: null, groupKind: 'circle' };
  });
}
